import { Modal } from '@design-system/components/modal/modal';
import { LibraryVM } from '../view-models/library.viewModel';
import { Button } from '@design-system/components/button/button';
import { Input } from '@design-system/components/input/input';
import { useRef } from 'react';

export const AddFolderModal = (p: LibraryVM) => {
  const input = useRef<HTMLInputElement>(null);
  return (
    <Modal
      isOpen={p.openModal.type === 'AddFolder'}
      onClose={() => p.dispatch('closeConfirmation')}
      title="New Folder"
      disableBackdropClick={true}
      hideCloseButton={true}
      modalClassName="w-full md:w-[450px]"
    >
      <div className="flex flex-col gap-6">
        <div>
          <Input
            ref={input}
            min={1}
            max={255}
            error={p.addFolderError}
            onChange={() => {
              p.addFolderError && p.dispatch('clearAddFolderError');
            }}
          />
        </div>
        <div className="flex justify-between">
          <Button
            onClick={() => p.dispatch('closeConfirmation')}
            color="neutral"
            variant="text"
          >
            Cancel
          </Button>
          <Button
            onClick={() =>
              input?.current?.value &&
              p.dispatch('addFolder', {
                name: input.current.value,
                parentId: p.openedFolderId || undefined,
              })
            }
            color="neutral"
          >
            Create
          </Button>
        </div>
      </div>
    </Modal>
  );
};
